'use client'
import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import LinkComponent  from '@components/LinkComponent'
import BlogCard from '@components/BlogCard'

const BlogCardSlider = ({ title, description, blogSlider, blogs, url, cardStyle, dictionary, lang }) => {

  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])

  if (!mounted) {
    const maxSlides =
      blogSlider?.blogSlider?.desktop ||
      blogSlider?.blogSlider?.tablet  ||
      Math.ceil(blogSlider?.blogSlider?.mobile || 1.2) ||
      3
    const limited = blogs.slice(0, maxSlides)
    return (
      <section className='carousel-wrapper lg:pl-0 pl-3'>
        {url ? (
          <LinkComponent href={url}>
            <h2 className='carousel-title-align'>{title?.[lang]}</h2>
          </LinkComponent>
        ) : (
          <h2 className='carousel-title-align'>{title?.[lang]}</h2>
        )}
        {description?.[lang]?.trim() && (
          <p className='carousel-description-align'>{description[lang]}</p>
        )}
        <div className="flex flex-row" style={{ gap: '16px' }}>
          {limited.map((blog, i) => (
            <BlogCard key={i} item={blog} cardStyle={cardStyle} dictionary={dictionary?.card} lang={lang} />
          ))}
        </div>
      </section>
    )
  }

  return (
    <section className='carousel-wrapper w-full lg:pl-0 pl-3'>
      {url ? (
        <LinkComponent href={url}>
          <h2 className='carousel-title-align'>{title?.[lang]}</h2>
        </LinkComponent>
      ) : (
        <h2 className='carousel-title-align'>{title?.[lang]}</h2>
      )}
      {description?.[lang]?.trim() && (
        <p className='carousel-description-align'>{description[lang]}</p>
      )}
      <Swiper
        spaceBetween={16}
        navigation
        modules={[Navigation]}
        slidesPerView={blogSlider.blogSlider.mobile || 1.2}
        breakpoints={{
          768:  { slidesPerView: blogSlider.blogSlider.tablet  || 2 },
          1024: { slidesPerView: blogSlider.blogSlider.desktop || 3 },
        }}
      >
        {blogs.map((blog, i) => (
          <SwiperSlide key={i}>
            <BlogCard item={blog} cardStyle={cardStyle} dictionary={dictionary?.card} lang={lang} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default BlogCardSlider